<template>
    <div id="SelectGroup">
        <YD-dialog :show.sync="selectShow" @close-animation-end="closeEnd">
            <div class="dialog">
                <div class="SelectGroup_list">
                    <ul>
                        <li v-for="({
                                GroupSetting,
                                EnrollNum,
                                EnrollDoublesNum
                            },index) in groups" :key="index"
                            :class="{'active':groupId == GroupSetting.LeagueGroupId}"
                            @click.stop="selectGroup(GroupSetting)"
                            v-html="GroupSetting.LeagueGroupName + numText(GroupSetting,EnrollNum,EnrollDoublesNum)"
                        >
                        </li>
                    </ul>
                </div>
                <div class="SelectGroup_option">
                    <button @click="selectShow = false">取消</button>
                </div>
            </div>
        </YD-dialog>
    </div>
</template>
<script>
import Vue from 'vue';
import Dialog from '@/components/Dialog';
Vue.use(Dialog);
export default {
    name:"SelectGroup",
    props:{
        groupId: {
            type: Number,
            default: 0
        },
        groups:{
            type:Array,
            required: true,
            default:()=>[]
        },
        show: Boolean
    },
    data(){
        return {
            selectShow: false
        }
    },

    watch:{
        show(newVal){
            this.selectShow = newVal;
        }
    },
    methods:{
        closeEnd(){
            this.$emit('update:show',false);
        },
        selectGroup({LeagueGroupId}){
            if(this.groupId != LeagueGroupId){
                this.$emit('change', LeagueGroupId);
            }
            this.selectShow = false;
        },
        numText({GroupType}, EnrollNum, EnrollDoublesNum){
            var text = "";
            if(GroupType == 3){
                if(EnrollDoublesNum > 0){
                    text = `（<i>${EnrollDoublesNum}</i>对）`;
                }else if(EnrollNum > 0){
                    text = `（<i>${EnrollNum}</i>人待组合）`;
                }
            }else if(EnrollNum > 0){
                text = `（<i>${EnrollNum}</i>人）`;
            }
            return text;
        },
    }
}
</script>
<style lang="scss" scoped>
.dialog{
    height: 70vh;
    max-height: 830px;
    padding-top: 56px;
    box-sizing: border-box;
    position: relative;
}
.SelectGroup_list{
    height: 100%;
    width: 100%;
    @include scroll;
    ul {
        padding-bottom: 144px;
        li{
            width: 100%;
            min-height: 104px;
            line-height: 40px;
            font-size: 28px;
            color: #1B1C1E;
            text-align: center;
            font-weight: 400;
            padding: 32px 40px;
            box-sizing: border-box;
			word-break: break-all;
            &.active{
                color: #7AD21A;
                font-weight: 500;
            }
            i{
                font-weight: 700;
                margin-left: 9px;
                font-style: normal;
            }
        }
    }
}
.SelectGroup_option{
    @include bottom-button;
    position: absolute;
    bottom: -68px;
}
</style>